import React from 'react';
import {Link} from 'react-router-dom';
import {withStyles} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Help from '@material-ui/icons/Help';
import logo from '../../assets/images/logo.png';

const styles = {
    root: {
        textAlign: 'left',
        flexGrow: 1,
    },
    grow: {
        display: 'flex',
        justifyContent: "space-between",
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20,
    },
    link: {
        textDecoration: 'none',
        color: '#fff'
    },

};

const Header = (props) => {

    const {classes, help} = props;

    return (
        <div className={classes.root}>
            <AppBar position="static">
                <Toolbar className={classes.grow}>
                    <div>
                        <img src={logo}/>
                    </div>
                    <div className={classes.help}>
                        <Button color="inherit">
                            <Link className={classes.link} to="/"
                                  onClick={() => help}><Help/>
                            </Link>
                        </Button>
                    </div>
                </Toolbar>
            </AppBar>
        </div>
    );
};

export default withStyles(styles)(Header);
